import React, { useRef, useState } from "react";
import styles from "../AssistantTestModule.module.scss";

export const SystemInstruction = ({ activeAssistant }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const textRef = useRef(null);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className={styles.system}>
      <div className={styles.systemContainer}>
        <div className={styles.systemTitle}>Система</div>

        <div
          className={`${styles.systemTextWrapper} ${
            isExpanded ? styles.expanded : ""
          }`}
        >
          <div
            ref={textRef}
            className={`${styles.systemText} ${
              isExpanded ? styles.expanded : ""
            }`}
          >
            {activeAssistant?.settings?.instruction}
          </div>
        </div>

        <div className={styles.showMore} onClick={toggleExpanded}>
          {isExpanded ? "Скрыть" : "Показать полностью"}
        </div>
      </div>
    </div>
  );
};
